module.exports = __webpack_public_path__ + "static/media/moons_ortodoncia_invisible-375.9020ae6a.webp";